<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/scvKvb/tc-custom/9781526729941.jpg?1729185165542" alt="This image is the cover for the book Gresley and His Locomotives"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Gresley and His Locomotives
      </h1>
      <p class="bookDescription body article font2">
        <b>An in-depth look at the team who worked with the renowned British railway engineer, with numerous photos included.</b><br/><br/>To renowned engineer Nigel Gresley must go great credit for many of the London and North Eastern Railway’s achievements, but those around him have faded into obscurity and are now largely forgotten, even though their contributions were immense. To redress this imbalance, Tim Hillier-Graves has explored the life of Gresley and his team, and sought to uncover a more expansive picture of these events. This in no way diminishes Gresley’s stunning accomplishments—but builds a fuller and more authentic view of a dynamic period in railway history.<br/><br/>The book draws upon many sources of information, some of it previously unpublished, to present a fascinating picture of all that happened and all that was achieved, often in the most difficult of circumstances, by a very gifted team of engineers and their exceptional leader.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tim Hillier-Graves
      </h2>
      
      <p class="authorDescription body article">Tim Hillier-Graves was born in North London in 1951. From an early age he was fascinated by steam locomotives. In 1972, Tim joined the Navy Department of the MOD and saw wide service in many locations. He retired in 2011, having specialized in Human Resource Management, then the management of the MOD's huge housing stock as one of the department`s Assistant Directors for Housing. On the death of his uncle in 1984, he became the custodian of a substantial railway collection and in retirement has spent considerable time reviewing and cataloging this material.  He has published a number of books on locomotives and aviation.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword/Pen and Sword Transport
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a0caeb4e